import * as React from "react"

const LeftIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48">
    <path d="M30.83 32.67l-9.17-9.17 9.17-9.17L28 11.5l-12 12 12 12z"></path>
  </svg>
)

export default LeftIcon
